// extracted by mini-css-extract-plugin
module.exports = {"button":"OrderByPanel_button__exfKY","selected":"OrderByPanel_selected__OBBR4","label":"OrderByPanel_label__y1b6f"};